import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  GetNotificationGQL,
  Notification_Set_Input,
  UpdateNotificationGQL,
  SendNotificationGQL,
  ChangePasswordGQL
} from "../../generated/graphql";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private getNotificationGQL: GetNotificationGQL,
    private updateNotification: UpdateNotificationGQL,
    private sendNotificationGQL: SendNotificationGQL,
    private changePasswordGQL: ChangePasswordGQL,
  ) { }

  getNotification(): Observable<any> {
    return this.getNotificationGQL.fetch({}).pipe(map((result) => result.data.notification));
  };

  UpdateNotification($input: Notification_Set_Input, $id: String): Observable<any> {
    return this.updateNotification.mutate({ uuid: $id, _set:$input});
  }

  sendNotification($company_id: string[], $message: string, $subject: string, $to_dipendenti: boolean){
    return this.sendNotificationGQL.mutate({ company_id: $company_id, message: $message, subject: $subject, to_dipendenti: $to_dipendenti }).pipe(map((result) => result));
  }

}
